import { useMsal } from '@azure/msal-react';
import { Box, Button, ButtonProps, Divider, Icons, Stack, styled, Tooltip, Typography } from '@healthinal/ui';
import { createLink, Link, LinkComponent, MatchRoute } from '@tanstack/react-router';
import { ComponentProps, forwardRef } from 'react';
import { HEADER_HEIGHT_PX, MAX_WIDTH_PX, theme } from '../../theme.ts';
import { SwitchModeButton } from './SwitchModeButton.tsx';

export function Header() {
  const { instance: msalInstance } = useMsal();

  return (
    <HeaderContainer>
      <Stack direction="row" sx={{ px: 3, height: HEADER_HEIGHT_PX }} justifyContent="space-between">
        <Stack direction="row" gap={1} alignItems="center">
          <MenuButton startDecorator={<Icons.FormatListBulleted />} to="/todos">
            ToDos
          </MenuButton>
          <MenuButton startDecorator={<Icons.AllInbox />} to="/masterdata">
            Stammdaten
          </MenuButton>
          <MenuButton startDecorator={<Icons.Person />} to="/patients">
            TB-Fälle
          </MenuButton>
          <MenuButton startDecorator={<Icons.Groups />} to="/contact-tracing">
            Umgebungsuntersuchung
          </MenuButton>
          <MenuButton startDecorator={<Icons.Checklist />} to="/screening">
            Screening
          </MenuButton>
          <MenuButton startDecorator={<Icons.History />} to={'/history'}>
            Verlauf
          </MenuButton>
        </Stack>
        <Stack direction="row" gap={1} alignItems="center">
          <Tooltip
            variant="outlined"
            title={
              <Box display="flex" flexDirection="column" alignItems="center">
                <Button endDecorator={<Icons.Logout />} variant="plain" onClick={() => msalInstance.logoutRedirect()}>
                  Logout
                </Button>
              </Box>
            }>
            <Typography level="title-md">{msalInstance.getActiveAccount()?.name}</Typography>
          </Tooltip>
          <SwitchModeButton />
        </Stack>
      </Stack>
      <Divider />
    </HeaderContainer>
  );
}

const ButtonWrapper = forwardRef<HTMLAnchorElement, Omit<ButtonProps<typeof Link>, 'component'>>(
  function ButtonWrapper(props, ref) {
    return <Button ref={ref} component={Link} {...props} />;
  },
);
const ButtonLink = createLink(ButtonWrapper);

function MenuButton({ ...props }: Omit<ComponentProps<LinkComponent<typeof ButtonWrapper>>, 'mask' | 'from'>) {
  return (
    <MatchRoute {...props} fuzzy>
      {(match) => <ButtonLink size="sm" color="neutral" {...props} variant={match ? 'solid' : 'soft'} />}
    </MatchRoute>
  );
}

const HeaderContainer = styled(Stack)({
  position: 'fixed',
  zIndex: 100,
  top: 0,
  width: '100%',
  maxWidth: MAX_WIDTH_PX,
  height: HEADER_HEIGHT_PX,
  backdropFilter: 'blur(16px)',
  background: `color-mix(in srgb, ${theme.vars.palette.background.body} 64%, transparent)`,
});
